import React from 'react';

function Slovakia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123999)">
        <mask
          id="mask0_800_123999"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123999)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#3D58DB"
          />
          <mask
            id="mask1_800_123999"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_123999)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#E31D1C"
            />
            <path
              d="M17.5544 6.03033L18.0509 5.97091L17.9982 5.53033H17.5544H7.13798H6.67447L6.63941 5.99251L7.13798 6.03033L6.6394 5.99261L6.63939 5.99282L6.63932 5.99363L6.63909 5.99671L6.6382 6.00867L6.63476 6.05498L6.62199 6.23131C6.61113 6.38378 6.59588 6.60314 6.57834 6.87121C6.54326 7.40717 6.49893 8.13874 6.46199 8.92034C6.38931 10.458 6.34054 12.2666 6.46752 13.1147C6.71718 14.7823 7.85376 18.4573 12.1712 20.115L12.3535 20.185L12.5351 20.1129C16.6353 18.4832 18.0289 15.1864 18.3517 13.1178C18.5138 12.0791 18.4313 10.2678 18.3184 8.76917C18.2611 8.00851 18.1943 7.30964 18.1418 6.80111C18.1156 6.54673 18.0929 6.3397 18.0768 6.19603C18.0687 6.12419 18.0623 6.06818 18.0578 6.02999L18.0527 5.98634L18.0514 5.975L18.051 5.97204L18.0509 5.97124L18.0509 5.97102C18.0509 5.97096 18.0509 5.97091 17.5544 6.03033Z"
              fill="#E31D1C"
              stroke="white"
            />
            <mask
              id="mask2_800_123999"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="5"
              y="5"
              width="14"
              height="16"
            >
              <path
                d="M17.5544 6.03033L18.0509 5.97091L17.9982 5.53033H17.5544H7.13798H6.67447L6.63941 5.99251L7.13798 6.03033L6.6394 5.99261L6.63939 5.99282L6.63932 5.99363L6.63909 5.99671L6.6382 6.00867L6.63476 6.05498L6.62199 6.23131C6.61113 6.38378 6.59588 6.60314 6.57834 6.87121C6.54326 7.40717 6.49893 8.13874 6.46199 8.92034C6.38931 10.458 6.34054 12.2666 6.46752 13.1147C6.71718 14.7823 7.85376 18.4573 12.1712 20.115L12.3535 20.185L12.5351 20.1129C16.6353 18.4832 18.0289 15.1864 18.3517 13.1178C18.5138 12.0791 18.4313 10.2678 18.3184 8.76917C18.2611 8.00851 18.1943 7.30964 18.1418 6.80111C18.1156 6.54673 18.0929 6.3397 18.0768 6.19603C18.0687 6.12419 18.0623 6.06818 18.0578 6.02999L18.0527 5.98634L18.0514 5.975L18.051 5.97204L18.0509 5.97124L18.0509 5.97102C18.0509 5.97096 18.0509 5.97091 17.5544 6.03033Z"
                fill="white"
                stroke="white"
              />
            </mask>
            <g mask="url(#mask2_800_123999)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5394 6.58972C11.5394 6.58972 11.7717 6.90434 11.8757 7.38543C11.9797 7.86651 11.9976 8.70943 11.9976 8.70943L9.79389 8.46824V9.95353L12.0469 9.69849L12.0102 11.1082C12.0102 11.1082 11.3362 11.1703 10.7834 11.1082C10.2306 11.0461 9.1416 10.7859 9.1416 10.7859V12.4863C9.1416 12.4863 10.248 12.1717 10.7834 12.0995C11.3188 12.0273 12.0102 12.0995 12.0102 12.0995V14.1878H12.9249V12.0995C12.9249 12.0995 13.9248 12.0222 14.5212 12.1058C15.1177 12.1895 15.6834 12.4863 15.6834 12.4863V10.7859C15.6834 10.7859 15.1102 11.0398 14.5696 11.1029C14.029 11.1661 12.9249 11.1082 12.9249 11.1082L12.9615 9.69849C12.9615 9.69849 13.7099 9.62961 14.1298 9.68028C14.5496 9.73094 15.0752 9.95353 15.0752 9.95353V8.46824C15.0752 8.46824 14.563 8.71598 14.16 8.76092C13.7569 8.80586 12.9123 8.70943 12.9123 8.70943C12.9123 8.70943 12.9273 7.83956 13.0139 7.416C13.1006 6.99244 13.346 6.58972 13.346 6.58972H11.5394Z"
                fill="#F7FCFF"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.75952 16.2452C7.75952 16.2452 8.25395 15.302 9.05848 15.1226C9.863 14.9433 10.7066 15.6839 10.7066 15.6839C10.7066 15.6839 11.2218 14.1875 12.4774 14.1875C13.733 14.1875 14.1737 15.6839 14.1737 15.6839C14.1737 15.6839 14.7094 15.1226 15.4797 15.1226C16.2501 15.1226 16.9639 16.2452 16.9639 16.2452C16.9639 16.2452 14.6628 19.9587 12.3617 19.9587C10.0606 19.9587 7.75952 16.2452 7.75952 16.2452Z"
                fill="#2E42A5"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123999">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Slovakia;
